<template>
  <el-row>
    <el-col :span="24">
      <el-card v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Import Tracks User</p>
          <div>
            <el-button v-if="trackForDownload.length < 1" class="btn-main" @click="showCheckboxes">
              Download
            </el-button>
            <el-button v-else class="btn-main" @click="downloadTracks(trackForDownload)">
              Download Tracks
            </el-button>
            <el-button type="success" class="btn-main" @click="generateAll">
              Generate all files
            </el-button>
            <el-button type="success" class="btn-main" @click="publishAll">
              Publish all tracks
            </el-button>
            <el-tooltip content="Upload track" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-upload2"
                @click="setDialogUpload(true)"
              ></el-button>
            </el-tooltip>
            <DialogTrack page="user"/>
          </div>
        </div>
        <div class="import-table-wrap">
        <div>
        <el-table :data="data" class="w100 import-user" :row-class-name="tableRowClassName" height="100vh">
          <el-table-column v-if="download_track"  width="50">
            <template slot-scope="props">
              <div style="width: 25px;overflow: hidden">
                <el-checkbox v-if="props.row.files_generated" v-model="trackForDownload"
                             :label="props.row.id" class="checkbox-track"></el-checkbox>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Cover" prop="user_id" width="150" sortable>
            <template slot-scope="props">
              <el-popover placement="right" width="220" trigger="hover"
                          :disabled="props.row.admin_errors.length < 1 && +props.row.isrc !== 1">
                <el-badge :value="props.row.admin_errors.length > 0 ? 'error' : 'isrc'" class="item" slot="reference"
                          :hidden="props.row.admin_errors.length < 1 && +props.row.isrc !== 1"
                          :type="+props.row.isrc === 1 ? 'success' : ''">
                  <img v-if="props.row.image_url" class="avatar" :src="props.row.image_url"/>
                  <img v-else class="avatar" :src="`https://app.syncvault.com/static/apple-touch-icon.png`"/>
                </el-badge>
                <div v-if="props.row.admin_errors.length > 0">
                  <h4 class="m0 p0">Errors</h4>
                  <ul class="mt5 p0">
                    <li v-for="error in props.row.admin_errors" :key="error">{{ error }}</li>
                  </ul>
                </div>
                <div v-if="+props.row.isrc === 1">ISRC code needs to be generated</div>
              </el-popover>
              <i class="el-icon-notebook-2 fa-lg pointer" @click="openMetadata(props.row)"></i>
            </template>
          </el-table-column>
          <el-table-column label="Title" sortable width="300">
            <template slot-scope="props">
              <div>
                {{ props.row.title }}
              </div>
              <div v-if="props.row.files_generated">
                <Waveform :track="props.row" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Submitted at" prop="submitted_at" sortable width="120">
            <template slot-scope="props">
              {{ props.row.submitted_at | date }}
            </template>
          </el-table-column>
          <el-table-column label="ISRC" prop="isrc" sortable>
            <template slot-scope="props">
              {{ +props.row.isrc === 1 ? '' : props.row.isrc }}
            </template>
          </el-table-column>
          <el-table-column
            label="Artist"
            prop="artist.name"
            sortable
            width="100"
          ></el-table-column>
          <el-table-column label="Email" sortable width="200">
            <template slot-scope="props"> {{ props.row.user ? props.row.user.email : '/' }} </template>
          </el-table-column>
          <el-table-column label="CID Ingestion" prop="delivered" sortable width="130" align="center">
            <template slot-scope="props">
              {{ props.row.delivered ? 'Delivered' : 'Pending' }}
            </template>
          </el-table-column>
          <el-table-column label="CID Territories" prop="cid_territories_option" sortable width="150">
            <template slot-scope="props">
              <span v-if="props.row.cid_territories_option === 'worldwide'">Worldwide</span>
              <span v-else-if="props.row.cid_territories_option === 'only'" class="pointer" @click="openModal(props.row)">
                <el-tag type="success">Only selected</el-tag>
              </span>
              <span v-else-if="props.row.cid_territories_option === 'except'" class="pointer" @click="openModal(props.row)">
                <el-tag type="warning">All except deselected</el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="CID Policy" prop="cid_policy" sortable width="120">
            <template slot-scope="props">
              <span v-if="props.row.cid_policy === 'monetize'">Monetize All</span>
              <span v-else-if="props.row.cid_policy === 'block'">Block All</span>
              <span v-else-if="props.row.cid_policy === 'review'">Route to Review</span>
              <span v-else-if="props.row.cid_policy === 'track'">Track policy</span>
              <span v-else-if="props.row.cid_policy === 'customize'">Customize</span>
            </template>
          </el-table-column>
          <el-table-column label="Owner" prop="content_owner" sortable width="120"></el-table-column>
          <el-table-column label="Uploaded By" prop="user_level" sortable width="120">
            <template slot-scope="props">
              <el-tooltip :content="props.row.user ? `${props.row.user.first_name} ${props.row.user.surname}` : 'Unknown'"
                          placement="top"> <span class="pointer">{{ uploadedBy(props.row.user) }}</span> </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="Generated" width="100%">
            <template slot-scope="props">
              <el-tag v-if="props.row.files_generated" type="success">
                Yes
              </el-tag>
              <el-tag v-else type="danger">
                No
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Published" width="100%">
            <template slot-scope="props">
              <el-tag v-if="props.row.user_publish === 1" type="success">
                Yes
              </el-tag>
              <el-tag v-else type="danger">
                No
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Timing period" width="140%">
            <template slot-scope="props">
              <span v-if="props.row.timing_start">
                {{ props.row.timing_start | day_month }} -
                {{ props.row.timing_end | date }}
              </span>
              <span v-else>Timing not set</span>
            </template>
          </el-table-column>
          <el-table-column label="Analysis ">
            <template slot-scope="props">
              <el-tag v-if="!props.row.analysis" type="warning">None</el-tag>
              <el-tag v-else-if="props.row.analysis === 'InProgress'" type="info">
                <i class="fa fa-spinner fa-spin"></i> Analyzing
              </el-tag>
              <el-tag v-else-if="props.row.analysis === 'Finished'" type="success">
                {{ props.row.analysis }}
              </el-tag>
              <el-tag v-else-if="props.row.analysis === 'Failed'" type="error">
                {{ props.row.analysis }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Actions" align="right" width="320">
            <template slot-scope="props">
              <el-tooltip v-if="+props.row.user_publish !== 2" content="Status" placement="top">
                <el-popover placement="left" trigger="click" width="300">
                  <el-button slot="reference" class="mr10"
                             circle size="small" icon="el-icon-check"></el-button>
                  <div class="video-status">
                    <p class="m0">Edit status for track <b>{{ props.row.title }}</b></p>
                    <el-radio-group class="mt10" v-model="props.row.approved" size="small"
                                    @change="changeTrackStatus($event, props.row)">
                      <el-radio-button :label="1">Approve{{ props.row.approved === 1 ? 'd' : ''}}</el-radio-button>
                      <el-radio-button :label="2">Reject{{ props.row.approved === 2 ? 'ed' : ''}}</el-radio-button>
                    </el-radio-group>
                  </div>
                </el-popover>
              </el-tooltip>
              <el-tooltip content="Allow" placement="top" v-if="props.row.errors.includes('Copyright issue')">
                <el-button type="info" circle size="small" icon="el-icon-star-off" @click="allow(props.row.id)">
                </el-button>
              </el-tooltip>
              <el-tooltip
                content="Generate files"
                placement="top"
                v-if="!props.row.files_generated"
              >
                <el-button
                  type="primary"
                  circle
                  size="small"
                  icon="el-icon-refresh"
                  @click="generate(props.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                content="Publish"
                placement="top"
                v-if="props.row.user_publish !== 1"
              >
                <el-button
                  type="success"
                  circle
                  size="small"
                  icon="el-icon-top"
                  @click="publish(props.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="Edit" placement="top" v-if="props.row.user_publish !== 1">
                <el-button
                  type="warning"
                  circle
                  size="small"
                  icon="el-icon-edit"
                  @click="openEdit(props.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                content="Delete"
                placement="top"
                v-if="props.row.user_publish !== 1"
              >
                <el-button
                  type="danger"
                  circle
                  size="small"
                  icon="el-icon-close"
                  @click="deleteT(props.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip v-if="!props.row.analysis" content="Analyze" placement="top">
                <el-button type="info" circle size="small" icon="el-icon-video-play" @click="analyzeTrack(props.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        </div>
        </div>
      </el-card>
    </el-col>
    <CountryModal />
    <DialogACRMetadata />
  </el-row>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import DialogTrack from './DialogTrack'
import DialogACRMetadata from "@/modules/admin/track-import/components/DialogACRMetadata.vue"
import CountryModal from "./CountryModal.vue";
import Waveform from './Waveform.vue'
import axios from '@/plugins/axios'

export default {
  data() {
    return {
      trackForDownload: []
    }
  },
  components: {
    DialogTrack, CountryModal, Waveform, DialogACRMetadata
  },

  computed: {
    ...mapState('trackImport', ['loading', 'data','pricing', 'download_track'])
  },

  methods: {
    ...mapActions('trackImport', [
      'read',
      'generate',
      'userPublish',
      'deleteTrack',
      'setApproveStatus',
      'downloadTrack',
      'analyzeTrack',
      'ddex_dialog',
      'allow'
    ]),
    ...mapMutations('newReleasesArtists', ['setOrdering']),
    ...mapMutations('trackImport', [
      'setTrack',
      'setDialogTrack',
      'setDialogUpload',
      'setUploadImage',
      'setGenres',
      'setMoods',
      'setRestrictions',
      'setSocials',
      'setPricing',
      'setDownloadTrack',
      'setCountryModal',
      'setDialogDDEX',
      'setAcrCloudDataDialog'
    ]),

    tableRowClassName({ row }) {
      if (+row.user_publish === 2) return 'info-row'
      if (+row.approved === 1) return 'success-row'
      else if (+row.approved === 2) return 'danger-row'
      return ''
    },

    uploadedBy(user) {
      if (user) {
        let obj = { sysadmin: 'Admin', label_admin: 'Label', artist_admin: 'Artist' }
        return obj[user.user_level] || 'Unknown'
      }
      return 'Unknown'
    },

    publish(id) {
      this.$confirm('You will publish this track. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.userPublish(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Publish cancelled'
          })
        })
    },

    openModal(track) {
      this.setCountryModal(true)
      this.setTrack(track)
    },

    generateAll() {
      this.$confirm(
        'You will generate files for all tracks. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.generate()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Generate cancelled'
          })
        })
    },

    changeTrackStatus(value, track) {
      track.approved = value
      this.setApproveStatus(track)
    },

    publishAll() {
      this.$confirm('You will publish tracks. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.userPublish()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Publish cancelled'
          })
        })
    },

    deleteT(id) {
      this.$confirm(
        'You will permanently delete this track. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.deleteTrack(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    },

    downloadTracks() {
      this.downloadTrack(this.trackForDownload)
      this.trackForDownload = []
    },

    showCheckboxes() {
      this.setDownloadTrack(!this.download_track)
    },

    openEdit(track) {
      if (track.short_challenge.budget > 0) track.short_challenge.budget = track.short_challenge.budget / 10;
      if (track.short_challenge.guaranteed_payment > 0) track.short_challenge.guaranteed_payment = track.short_challenge.guaranteed_payment / 10;
      if (track.short_challenge.bonus_payment > 0) track.short_challenge.bonus_payment = track.short_challenge.bonus_payment / 10;

      if (track.tiktok_challenge.budget > 0) track.tiktok_challenge.budget = track.tiktok_challenge.budget / 10;
      if (track.tiktok_challenge.guaranteed_payment > 0) track.tiktok_challenge.guaranteed_payment = track.tiktok_challenge.guaranteed_payment / 10;
      if (track.tiktok_challenge.bonus_payment > 0) track.tiktok_challenge.bonus_payment = track.tiktok_challenge.bonus_payment / 10;

      if (track.instagram_challenge.budget > 0) track.instagram_challenge.budget = track.instagram_challenge.budget / 10;
      if (track.instagram_challenge.guaranteed_payment > 0) track.instagram_challenge.guaranteed_payment = track.instagram_challenge.guaranteed_payment / 10;
      if (track.instagram_challenge.bonus_payment > 0) track.instagram_challenge.bonus_payment = track.instagram_challenge.bonus_payment / 10;
      this.setDialogTrack(true)
      this.setTrack(JSON.parse(JSON.stringify(track)))
      this.setUploadImage(track.image_url)
      track.tiktok_pricing =  this.pricing.map(obj1 => {
        const obj2 = track.tiktok_challenge ? track.tiktok_challenge.pricing.find(obj2 => obj2.pricing_id === obj1.id) :{};
        return {
          id: obj1.id,
          threshold: obj1.threshold,
          payment: obj2 ? obj2.payment : null
        }
      });
      track.instagram_pricing =  this.pricing.map(obj1 => {
        const obj2 = track.instagram_challenge ? track.instagram_challenge.pricing.find(obj2 => obj2.pricing_id === obj1.id) :{};
        return {
          id: obj1.id,
          threshold: obj1.threshold,
          payment: obj2 ? obj2.payment : null
        }
      });
      track.short_pricing =  this.pricing.map(obj1 => {
        const obj2 = track.short_challenge ? track.short_challenge.pricing.find(obj2 => obj2.pricing_id === obj1.id): {};
        return {
          id: obj1.id,
          threshold: obj1.threshold,
          payment: obj2 ? obj2.payment : null
        }
      });
    },

    openMetadata(track) {
      this.setAcrCloudDataDialog(true)
      this.setTrack(track)
    }
  },

  async created() {
    this.read()
    this.setOrdering({column: 'artist.name', type:'asc'})

    let genres = await axios.api.get('/genres')
    if (genres.data.success) this.setGenres(genres.data.genres)

    let moods = await axios.api.get('/moods')
    if (moods.data.success) this.setMoods(moods.data.moods)

    let restrictions = await axios.api.get('/restrictions')
    if (restrictions.data.success) this.setRestrictions(restrictions.data.restrictions)

    let { data } = await axios.api.get('/socials')
    if (data) this.setSocials(data)

    let pricing = await axios.api.get('/challenge/pricing')
    if (pricing.data.success) {
      pricing.data.pricing.forEach(obj => {
        obj.payment = null; //added payment field for dialog form
      });
      this.setPricing(
        pricing.data.pricing
      )
    }
  },

  mounted() {
    window.Echo.private('track.processed').listen('.track.processed', e => {
      if (!e.trackId && e.serviceError) {
        this.$message({ type: 'error', message: e.serviceError })
        return
      }
      let searchCyaniteTrack = this.data.find(
        track => +track.cyaniteId === +e.trackId
      )
      if (searchCyaniteTrack) {
        searchCyaniteTrack.analysis = e.status

        if (e.status === 'Finished') this.read()
      }
    })
  }
}
</script>

<style lang="scss">
.import-user .item {
  margin-top: 1rem;
  cursor: pointer;
}

.import-user .checkbox-track span {
  width: 20px;
  height: 20px;
  border-color: #e55279;;
}

.el-table .success-row {
  background: rgba(125, 206, 175, .3);
}

.el-table .danger-row {
  background: rgba(208, 110, 110, .3)
}

.el-table .info-row {
  background: rgba(230, 162, 60, .3)
}

.import-table-wrap {
  overflow-x: scroll;

  & > div {
    width: 2200px;
  }
}
</style>
